import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'react-circular-progressbar/dist/styles.css';
import ReactApexChart from 'react-apexcharts';
import { graphAllData, RoomBookingData } from '../../Redux/action/roomAction';
import { dataUser, dataLocation } from '../Helpers/util';
import axiosInstance from '../../utils/axiosInstance';
import { param } from 'jquery';
import { toast } from 'react-toastify';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import SwButton from '../Common/SwButtons/SwButtons';
import SwModal from '../Common/SwModal/SwModal';
import AntDTable from '../Common/AntDTable/AntDTable';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
var CompanyId = UserObj ? UserObj.company_id : null;

/* Column key -> `sortBy` value accepted by meeting-room/api/booking/list.
   Mirrors the Sort by menu in RoomShort.js. */
const SORT_FIELD_BY_COLUMN_KEY = {
  resourceName: 'resourceName',
  resourceType: 'resourceType',
  date: 'bookingDate',
  amount: 'pricePerSlot',
};

const BOOKING_TYPES = [
  'Meeting Room',
  'Conference Room',
  'Training Room',
  'AV Lounge',
];

class RoomTable extends Component {
  constructor() {
    super();
    this.state = {
      tab: false,
      company_id: UserObj ? UserObj.company_id : null,
      RoomList: [],
      spinner: true,
      bookingId: '',
      modalOpen: false,

      sortColumnKey: null, // antd columnKey of the active sort
      sortOrder: null, // 'ascend' | 'descend' | null

      buildingOptions: [], // For the building dropdown
      floorOptions: [], // For the floor dropdown
      selectedBuilding: null, // Selected building object
      selectedFloor: null, // Selected floor object
      selectedBuildingId: null, // Selected building ID
      selectedFloorId: null, // Selected floor ID
      trainingRoomList: [],

      /*--CityWiseBooking--*/
      seriesCenterWiseBooking: [
        {
          name: 'Net Profit',
          data: [],
        },
      ],

      optionsCenterWiseBooking: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: '',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return '$' + val + ' thousands';
            },
          },
        },
      },

      /*--CityWiseBooking--*/
      /*--CityWiseBooking--*/
      seriesCityWiseBooking: [
        {
          name: 'Net Profit',
          data: [],
        },
      ],

      optionsCityWiseBooking: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: '',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return '$ ' + val + ' thousands';
            },
          },
        },
      },

      /*--CityWiseBooking--*/
      /*--seriesPopular--*/

      seriesPopular: [
        {
          name: 'SAMPLE A',
          data: [],
        },
      ],
      optionsPopular: {
        chart: {
          height: 250,
          type: 'scatter',
          zoom: {
            enabled: true,
            type: 'xy',
          },
        },
        xaxis: {
          tickAmount: 10,
          labels: {
            formatter: function (val) {
              return parseFloat(val).toFixed(1);
            },
          },
        },
        yaxis: {
          tickAmount: 7,
        },
      },

      /*--popular--*/
      /*--Booking--*/
      seriesBooking: [
        {
          name: 'Servings',
          data: [44, 55, 41, 67, 22, 43, 21, 33, 45, 31, 87, 65, 35],
        },
      ],
      optionsBooking: {
        annotations: {
          points: [
            {
              x: 'Bananas',
              seriesIndex: 0,
              label: {
                borderColor: '#775DD0',
                offsetY: 0,
                style: {
                  color: '#fff',
                  background: '#775DD0',
                },
                text: 'Bananas are good',
              },
            },
          ],
        },
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '50%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ['#fff', '#f2f2f2'],
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
          categories: [],
          tickPlacement: 'on',
        },
        yaxis: {
          title: {
            text: 'Servings',
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'horizontal',
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },

      /*--Booking--*/
      series2: [
        {
          name: 'Desktops',
          data: [],
        },
      ],
      options2: {
        chart: {
          height: 180,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          // text: 'Product Trends by Month',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },

      series3: [
        {
          name: 'Desktops',
          data: [],
        },
      ],
      options3: {
        chart: {
          height: 180,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          // text: 'Product Trends by Month',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },

      series: [],
      options: {
        chart: {
          width: 240,
          type: 'pie',
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },

      breakupMetingSeries: [],
      breakupMetingOption: {
        chart: {
          width: 240,
          type: 'pie',
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
    };
  }

  graphData = () => {
    // const formData = new FormData();
    // formData.append("company_id", this.state.company_id);
    const param = {
      company_id: this.state.company_id,
      location: JSON.stringify(LocationObj),
    };
    this.props.graphAllData(param);
  };

  allRoomList = () => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    const param = {
      clientId: newCompanyId.organizationId,
      pgno: this.props.pgno,
      row: this.props.row,
      propertyId: this.props.propertyId,
      type: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
    };
    this.props.RoomBookingData(param);
  };

  clickCancelData = (i, id) => {
    this.setState({ modalOpen: true });
    this.setState({ bookingId: id });
  };

  CancelBooking = async () => {
    this.setState({ modalOpen: false });

    const params = {
      bookingId: this.state.bookingId, // Pass the bookingId from state
    };

    const organizationData = JSON.parse(localStorage.getItem('headData'));

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }meeting-room/api/booking/cancel`,
        params, // ✅ Fix: Added missing comma
        {
          headers: {
            'req-organization-id': organizationData.organizationId,
            'req-organization-type': organizationData.roomShared,
          },
        },
      );

      if (response.status === 200) {
        toast.success(
          response.data.message || 'Booking cancelled successfully.',
        );
      } else {
        toast.error(response.data.message || 'Failed to cancel booking.');
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'An error occurred while canceling.',
      );
    } finally {
      this.allRoomList(); // ✅ Always refresh the room list
    }
  };

  componentDidMount() {
    this.graphData();
    this.seatBookingView();
  }

  componentDidUpdate(prevProps) {
    // RoomBookingFilter refetches at pgno 1 on apply, so keep the pagination
    // control in step instead of leaving it on the previous page.
    if (prevProps.filterData !== this.props.filterData) {
      this.setState({ currentPage: 1 });
    }
  }

  seatBookingView = () => {
    mixpanel.track('Reports Room booking analytics page view', {
      PageName: 'Room Booking',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Room Booking',
    });
  };

  componentWillReceiveProps(props) {
    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.roomtype &&
      this.props.roomReducer.RoomGraph.data.data.roomtype.count
    ) {
      this.state.breakupMetingSeries = this.props.roomReducer.RoomGraph.data.data.roomtype.count.map(
        items => parseInt(items),
      );
      this.setState({
        ...this.state,
      });
    }
    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.roomtype &&
      this.props.roomReducer.RoomGraph.data.data.roomtype.room_type
    ) {
      this.state.breakupMetingOption.labels = this.props.roomReducer.RoomGraph.data.data.roomtype.room_type;
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.daytime &&
      this.props.roomReducer.RoomGraph.data.data.daytime.count
    ) {
      this.state.series = this.props.roomReducer.RoomGraph.data.data.daytime.count.map(
        items => parseInt(items),
      );
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.daytime &&
      this.props.roomReducer.RoomGraph.data.data.daytime.time
    ) {
      this.state.options.labels = this.props.roomReducer.RoomGraph.data.data.daytime.time;
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.weekdays &&
      this.props.roomReducer.RoomGraph.data.data.weekdays.count
    ) {
      this.state.series2[0].data = this.props.roomReducer.RoomGraph.data.data.weekdays.count.map(
        items => parseInt(items),
      );
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.weekdays &&
      this.props.roomReducer.RoomGraph.data.data.weekdays.day
    ) {
      this.state.options2.xaxis.categories = this.props.roomReducer.RoomGraph.data.data.weekdays.day;
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.avgcount &&
      this.props.roomReducer.RoomGraph.data.data.avgcount.avg
    ) {
      this.state.series3[0].data = this.props.roomReducer.RoomGraph.data.data.avgcount.avg.map(
        items => parseInt(items),
      );
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.avgcount &&
      this.props.roomReducer.RoomGraph.data.data.avgcount.meeting_date
    ) {
      this.state.options3.xaxis.categories = this.props.roomReducer.RoomGraph.data.data.avgcount.meeting_date.map(
        items => parseInt(items),
      );
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.countbyroom &&
      this.props.roomReducer.RoomGraph.data.data.countbyroom.count
    ) {
      this.state.seriesBooking[0].data = this.props.roomReducer.RoomGraph.data.data.countbyroom.count.map(
        items => parseInt(items),
      );
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.countbyroom &&
      this.props.roomReducer.RoomGraph.data.data.countbyroom.meetingroom_code
    ) {
      this.state.optionsBooking.xaxis.categories = this.props.roomReducer.RoomGraph.data.data.countbyroom.meetingroom_code;
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.countbycity &&
      this.props.roomReducer.RoomGraph.data.data.countbycity.count
    ) {
      this.state.seriesCityWiseBooking[0].data = this.props.roomReducer.RoomGraph.data.data.countbycity.count.map(
        items => parseInt(items),
      );
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.countbycity &&
      this.props.roomReducer.RoomGraph.data.data.countbycity.city_name
    ) {
      this.state.optionsCityWiseBooking.xaxis.categories = this.props.roomReducer.RoomGraph.data.data.countbycity.city_name;
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.countbycenter &&
      this.props.roomReducer.RoomGraph.data.data.countbycenter.count
    ) {
      this.state.seriesCenterWiseBooking[0].data = this.props.roomReducer.RoomGraph.data.data.countbycity.count.map(
        items => parseInt(items),
      );
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.countbycenter &&
      this.props.roomReducer.RoomGraph.data.data.countbycenter.center
    ) {
      this.state.optionsCenterWiseBooking.xaxis.categories = this.props.roomReducer.RoomGraph.data.data.countbycenter.center;
      this.setState({
        ...this.state,
      });
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.countbytime &&
      this.props.roomReducer.RoomGraph.data.data.countbytime.count
    ) {
      this.state.seriesPopular[0].data = this.props.roomReducer.RoomGraph.data.data.countbytime.count;
      this.setState(
        {
          ...this.state,
        },
        () => { },
      );
    }

    if (
      this.props.roomReducer.RoomGraph &&
      this.props.roomReducer.RoomGraph.data &&
      this.props.roomReducer.RoomGraph.data.data &&
      this.props.roomReducer.RoomGraph.data.data.countbytime &&
      this.props.roomReducer.RoomGraph.data.data.countbytime.start_time
    ) {
      this.state.optionsPopular.xaxis.categories = this.props.roomReducer.RoomGraph.data.data.countbytime.start_time;
      this.setState({
        ...this.state,
      });
    }

    if (
      props.roomReducer.RoomtList &&
      props.roomReducer.RoomtList.status == 200
    ) {
      this.setState({
        spinner: false,
      });
      this.setState({
        RoomList:
          props.roomReducer.RoomtList &&
          props.roomReducer.RoomtList.data &&
          props.roomReducer.RoomtList.data.data &&
          props.roomReducer.RoomtList.data.data,
      });
    }
  }

  setTabset(val) {
    // alert(val);

    this.setState({
      tab: val,
    });
  }
  /* Builds the booking/list payload, carrying the active filters and sort
     along so they survive page changes. */
  buildListParams = ({ pgno, row }) => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    const { sortColumnKey, sortOrder } = this.state;

    // The filter payload carries its own pgno/row from when it was applied;
    // drop them so the page being requested wins.
    const {
      pgno: filterPgno,
      row: filterRow,
      ...activeFilters
    } = this.props.filterData || {};

    const params = {
      clientId: newCompanyId.organizationId,
      propertyId: this.props.propertyId,
      type: BOOKING_TYPES,

      // Filters carry their own propertyId/type, so they override the defaults.
      ...activeFilters,

      pgno,
      row,
    };

    if (sortColumnKey && sortOrder) {
      params.sortBy = SORT_FIELD_BY_COLUMN_KEY[sortColumnKey];
      params.orderBy = sortOrder === 'ascend' ? 'asc' : 'desc';
    }

    return params;
  };

  handleTableChange = (pagination, filters, sorter) => {
    const sortColumnKey = sorter?.order ? sorter.columnKey : null;
    const sortOrder = sorter?.order || null;

    // antd fires onChange for pagination too; only react to real sort changes.
    if (
      sortColumnKey === this.state.sortColumnKey &&
      sortOrder === this.state.sortOrder
    ) {
      return;
    }

    // Sorting reorders the whole result set server-side, so go back to page 1.
    this.setState(
      { sortColumnKey, sortOrder, currentPage: 1, spinner: true },
      () => {
        this.props.RoomBookingData(
          this.buildListParams({ pgno: 1, row: this.state.pageSize || 25 }),
        );
      },
    );
  };

  render() {
    const roomTableTable = this.props.roomReducer.RoomtList.data.data;

    const sortProps = columnKey => ({
      sorter: true,
      sortOrder:
        this.state.sortColumnKey === columnKey ? this.state.sortOrder : null,
    });

    const columns = [
      {
        title: "Room Name",
        dataIndex: "resourceName",
        key: "resourceName",
        ...sortProps("resourceName"),
      },
      {
        title: "Room Category",
        dataIndex: "resourceCategory",
        key: "resourceCategory",
        render: (val) => (val === true ? "Shared" : "Private"),
      },
      {
        title: "Room Type",
        dataIndex: "resourceType",
        key: "resourceType",
        ...sortProps("resourceType"),
        render: (val) => {
          if (val === "AV Lounge") return "Lounge Room";
          return val || "-";
        },
      },
      {
        title: "Location",
        key: "location",
        render: (_, record) =>
          record?.propertyDetails?.name || "-",
      },
      {
        title: "User Name",
        key: "user",
        render: (_, record) =>
          record?.hostDetails?.fname || "-",
      },
      {
        title: "Meeting Date",
        dataIndex: "start",
        key: "date",
        ...sortProps("date"),
        render: (val) =>
          val ? moment(val).format("DD MMM YYYY") : "-",
      },
      {
        title: "Start Time",
        dataIndex: "start",
        key: "start",
        render: (val) =>
          val
            ? new Date(val).toLocaleTimeString("en-IN", {
              timeZone: "Asia/Kolkata",
              hour12: false,
            })
            : "-",
      },
      {
        title: "End Time",
        dataIndex: "end",
        key: "end",
        render: (val) =>
          val
            ? new Date(val).toLocaleTimeString("en-IN", {
              timeZone: "Asia/Kolkata",
              hour12: false,
            })
            : "-",
      },
      {
        title: "Amount",
        dataIndex: "pricePerSlot",
        key: "amount",
        ...sortProps("amount"),
        render: (val) => val || "0",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (val) => {
          if (val === "Booked") return "Booked";
          if (val === "CheckIn") return "Check in";
          if (val === "Completed") return "Meeting ended";
          if (val === "Cancelled") return "Cancel";
          return "-";
        },
      },
      {
        title: "Cancel",
        key: "cancel",
        render: (_, record) =>
          record.status === "Booked" ? (
            <SwButton
              size="sm"
              variant="danger-outline"
              style={{ borderColor: "red" }}
              onClick={() =>
                this.clickCancelData(null, record._id)
              }
            >
              Cancel
            </SwButton>
          ) : (
            "NA"
          ),
      },
    ];
    return (
      <>
        <div className="tabSecForAll">
          {/* <ul className="tabs">
             <li className={`tab-link ${!this.state.tab ? "current" : ""}`} onClick={(e)=>this.setTabset(false)} >                
               Tabular Form
             </li>
             <li 
             className={`tab-link ${this.state.tab ? "current" : ""}`} onClick={(e)=>this.setTabset(true)}  >
               Graphical Form
             </li>
             </ul> */}
          
          <div className="mt-2">
          {!this.state.tab ? (
            <AntDTable
              rowKey="_id"
              columns={columns}
              dataSource={this.state.RoomList?.list || []}
              loading={this.state.spinner}
              pagination
              pageSize={this.state.pageSize}
              currentPage={this.state.currentPage}
              totalRecords={this.state.RoomList?.count || 0}
              onChange={this.handleTableChange}
              onPageChange={(page, pageSize) => {
                this.setState({
                  currentPage: page,
                  pageSize: pageSize,
                  spinner: true,
                });

                this.props.RoomBookingData(
                  this.buildListParams({ pgno: page, row: pageSize }),
                );
              }}
            />
          ) : (
            <div className="datachart">{/* charts */}</div>
          )}
        </div>


          <SwModal
            show={this.state.modalOpen}
            onClose={() => this.setState({ modalOpen: false })}
            size="sm"
            className="sw-small-modal"
            footer={
              <>
                <div className='d-flex justify-content-center align-items-center gap-3'>
                  <SwButton
                    size="sm"
                    variant="dark-outline"
                    onClick={() => this.setState({ modalOpen: false })}
                  >
                    No
                  </SwButton>

                  <SwButton
                    size="sm"
                    variant="primary"
                    onClick={() => this.CancelBooking()}
                  >
                    Yes
                  </SwButton>
                </div>
              </>
            }
          >
            <SwButton variant="" className='btn-close btn-close-custom' onClick={() => this.setState({ modalOpen: false })}></SwButton>
              
              

              <h3 className="SwModalSubHeading text-center">
                Are you sure you want to cancel this booking?
              </h3>
                
            
          </SwModal>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  roomReducer: state.roomReducer,
});

const mapActionsToProps = {
  graphAllData,
  RoomBookingData,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(RoomTable);
